import { Box } from '@primer/react';
import { BetterSystemStyleObject } from '@primer/react/lib/sx';
import { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { NotifyHelper } from '../../helpers/toast';

import styles from "./Upload.module.css";
import { uploadApi } from '../../api/uploadApi';
import { IUploadRespone } from '../../models/response/upload/IUploadRespone';
import Text from '../ui/text';
interface IUploadProps {
    sx?: BetterSystemStyleObject,
    onUploadSuccess: (data: IUploadRespone) => void,
    accept?: any,
    icon?: React.ReactNode
}
const Upload = (props: IUploadProps) => {
    const [isUploading, setIsUploading] = useState(false);
    const accept: any = props.accept ? props.accept : {
        'image/*': [],
        // 'application/pdf': [],
        // 'application/msword': ['.doc', '.docx'],
        // 'application/vnd.ms-excel': ['.xls', '.xlsx'],
        // 'application/msg': ['.msg'],
    }
    const onDrop = async (acceptedFiles: any) => {
        // Do something with the files
        console.log({
            acceptedFiles
        });
        if (acceptedFiles.length > 0) {
            setIsUploading(true)
            const res = props.accept ? await uploadApi.uploadFile(acceptedFiles[0]) : await uploadApi.uploadImage(acceptedFiles[0])
            setIsUploading(false)
            if (res.is_success) {
                props.onUploadSuccess(res.data)
                NotifyHelper.Success("Success")
            } else {
                NotifyHelper.Error(res.message ?? "Error")
            }
        }

    }
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: accept
    })
    return (
        <Box sx={props.sx}>
            <div {...getRootProps()}>


                <input {...getInputProps()}
                    accept="image/png, image/jpeg"
                />
                {/* {
                isDragActive ?
                    <p>Drop the files here ...</p> :
                    <p>Drag 'n' drop some files here, or click to select files</p>
            } */}
                <Box sx={{
                    p: 3,
                    textAlign: "center",
                    borderStyle: "dashed",
                    borderWidth: "1px",
                    borderColor: "border.default",
                    borderRadius: 2,
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    color: "fg.muted"
                }}
                    className={isDragActive ? styles.isDragActive : ""}
                >
                    {props.icon ? <Box>
                        {props.icon}
                    </Box> : null}
                    {isUploading && <Text text='Uploading...' />}
                    {!isUploading && <Text text='Base.Lable.Upload.PlaceHolder' />}
                </Box>
            </div>
        </Box>
    );
};

export default Upload;